export default __webpack_public_path__ + "static/media/storageUnit1-beforeB-1024w.3a86d6a2.png";